<template>
  <Section title="contact">
    <div class="temp-email">
      <font-awesome-icon :icon="['fas', 'envelope']" class="email-icon" />
      <p>Get in touch</p>
      <p>
        <a href="mailto:adele.angel.dev@gmail.com">adele.angel.dev@gmail.com</a>
      </p>
    </div>

    <!-- <ContactForm /> -->
  </Section>
</template>


<script>
// import ContactForm from "@/components/home/ContactForm";

export default {
  name: "ContactSection",
  // components: {
  //   ContactForm
  // }
};
</script>